var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:(_vm.pieStyle),attrs:{"id":_vm.comID}})
}
var staticRenderFns = []

export { render, staticRenderFns }